import { ChevronRight, MonitorPlay } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/Button/Button';
import { captureAnalyticsEvent } from '@/lib/mixpanel';
import { useAuthStore } from '@/stores/authStore';
import type { Center } from '@/types/center';

const DEMO_URLS = {
  schedulingInternal: 'https://learning.mathnasium.com/showcase/cmnzjyavh001j160jd5m3ra1t?utm_source=link&demo=1&step=1',
  schedulingExternal: 'https://learning.mathnasium.com/showcase/cmnzpwvtr01odz50kqhvsaub1?utm_source=link&demo=1&step=1',
  noScheduling: 'https://learning.mathnasium.com/showcase/cmnzlzfhx00m2160jhkias0tk?utm_source=link&demo=1&step=1',
} as const;

const getDemoUrl = (center: Center | undefined) => {
  if (!center?.features?.scheduling) {
    return DEMO_URLS.noScheduling;
  }

  return center.externalSchedulingUrl ? DEMO_URLS.schedulingExternal : DEMO_URLS.schedulingInternal;
};

export const InteractiveDemoCard = () => {
  const { t } = useTranslation('home', { keyPrefix: 'home' });

  const { userData } = useAuthStore();
  const demoUrl = getDemoUrl(userData?.center);

  return (
    <Button variant='link' className='bg-fill-background-light h-full justify-between gap-3 rounded-xl px-5 py-7' asChild>
      <a href={demoUrl} target='_blank' rel='noopener noreferrer' onClick={() => void captureAnalyticsEvent('interactivedemo_clicked')}>
        <div className='flex items-center gap-3'>
          <MonitorPlay className='text-text-brand-primary size-6' />
          <span className='text-body-m-semibold'>{t('interactiveDemoButton.label')}</span>
        </div>
        <ChevronRight className='text-text-default-secondary size-6' />
      </a>
    </Button>
  );
};
